import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import {
  fetchProjectHistory,
  ProjectFocusItem,
  ProjectHistoryItem,
  ProjectHistoryCounts,
} from "services/project-history.service";

const defaultCounts: ProjectHistoryCounts = {
  all: 0,
  activity: 0,
  note: 0,
  email: 0,
  file: 0,
  changelog: 0,
};

export function useProjectHistoryFeed(companyId: string, projectId: string) {
  const { t } = useTranslation();
  const [focus, setFocus] = useState<ProjectFocusItem[]>([]);
  const [history, setHistory] = useState<ProjectHistoryItem[]>([]);
  const [counts, setCounts] = useState<ProjectHistoryCounts>(defaultCounts);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchProjectHistory(companyId, projectId);
      setFocus(Array.isArray(data.focus) ? data.focus : []);
      setHistory(Array.isArray(data.history) ? data.history : []);
      setCounts({ ...defaultCounts, ...(data.counts || {}) });
    } catch {
      toast.error(
        t("project_history_load_failed", {
          defaultValue: "Could not load history.",
        })
      );
    } finally {
      setLoading(false);
    }
  }, [companyId, projectId, t]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { focus, history, counts, loading, reload };
}
